module.exports = __webpack_public_path__ + "prod/20250417163640/img/url-app.d88da72d.png";